import { render, staticRenderFns } from "./AcitveCardModal.vue?vue&type=template&id=a2ce2ffc&scoped=true"
import script from "./AcitveCardModal.vue?vue&type=script&lang=js"
export * from "./AcitveCardModal.vue?vue&type=script&lang=js"
import style0 from "./AcitveCardModal.vue?vue&type=style&index=0&id=a2ce2ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ce2ffc",
  null
  
)

export default component.exports